import { useQuery } from '@tanstack/react-query';
import { api, withQuery } from '../../core/client';

/** One entry of the site-local device-catalog replica (R-097 P3), read via gateway-local
 *  `/v1/device-catalog`. Read-only specs synced down from the cloud master catalog;
 *  `calibration`/`parameters` are JSON-object strings. Drives data-driven gauge ranges. */
export interface LocalDeviceCatalogEntry {
  kind: string;
  code: string;
  model?: string;
  name: string;
  unit?: string;
  min_value?: number;
  max_value?: number;
  capacity?: number;
  capacity_unit?: string;
  calibration: string;
  parameters: string;
  active: boolean;
}

/** Site-local device-catalog replica (active entries). Best-effort: consumers fall back to
 *  built-in ranges when this is empty/unavailable (e.g. on the cloud console, which has no
 *  local replica). The catalog changes rarely, so it's cached aggressively. */
export function useLocalDeviceCatalog() {
  return useQuery({
    queryKey: ['device-catalog-local'],
    queryFn: async () =>
      (
        await api.get<{ entries: LocalDeviceCatalogEntry[] }>(
          withQuery('/v1/device-catalog', { active_only: 'true' }),
        )
      ).entries ?? [],
    staleTime: 5 * 60 * 1000,
    retry: false, // absent on cloud/offline → fall back silently, don't hammer
  });
}
